export default __webpack_public_path__ + "static/img-atlantic-snapper-500x325-862d72650d30413b37da3bc4c70c9f6c.png";